module.exports = __webpack_public_path__ + "static/img/concat.7c5355c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/concat.jpg
// module id = wazF
// module chunks = 6